<template>
    <p class="p6">
        <slot />
    </p>
</template>
